var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotfound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 377,
    viewBox: "0 0 421 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 400,
    height: 350,
    rx: 5,
    fill: "#DF1545"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 350,
    rx: 5,
    fill: "#190429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.133 197.633L207.258 116.188C203.742 110.133 194.562 109.938 191.047 116.188L144.172 197.633C140.656 203.688 145.148 211.5 152.375 211.5H245.93C253.156 211.5 257.648 203.883 254.133 197.633ZM199.25 180.641C204.133 180.641 208.234 184.742 208.234 189.625C208.234 194.703 204.133 198.609 199.25 198.609C194.172 198.609 190.266 194.703 190.266 189.625C190.266 184.742 194.172 180.641 199.25 180.641ZM190.656 148.414C190.461 147.047 191.633 145.875 193 145.875H205.305C206.672 145.875 207.844 147.047 207.648 148.414L206.281 174.977C206.086 176.344 205.109 177.125 203.938 177.125H194.367C193.195 177.125 192.219 176.344 192.023 174.977L190.656 148.414Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/Notfound.af1cc33064f3d6bc8f1e91367376a3e0.svg";
export { ForwardRef as ReactComponent };